

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.defaults({ // 'inherit: false' pour contrer ces paramètres par défaut...
    overwrite:"auto", //* A VOIR
    // duration: 1,
    // delay: 0.3,
    // ease: 'power2.out', // default power1.out // https://greensock.com/docs/v3/Eases
})

gsap.config({
    force3D: false
})

// let tl = gsap.timeline();

gsap.registerPlugin(ScrollTrigger);

export default gsap
